import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CountdownBanner from "./components/CountdownBanner";
import HowItWorks from "./components/HowItWorks";
import MenuSection from "./components/MenuSection";
import IndividualMenuSection from "./components/IndividualMenuSection";
import Gallery from "./components/Gallery";
import ShareReveal from "./components/ShareReveal";
import Testimonials from "./components/Testimonials";
import CustomerReviews from "./components/CustomerReviews";
import FAQ from "./components/FAQ";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import OrderTracker from "./components/OrderTracker";
import { Toaster } from "@/components/ui/sonner";
import PageTracker from "./components/PageTracker";

function MainSite() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <PageTracker />
      <Navbar />
      <main>
        <HeroSection />
        <CountdownBanner />
        <HowItWorks />
        <MenuSection />
        <IndividualMenuSection />
        <Gallery />
        <ShareReveal />
        <Testimonials />
        <CustomerReviews />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/track" element={<OrderTracker />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
